import React, { useContext } from 'react';
import { FormControl, InputLabel, Select, MenuItem } from '@material-ui/core';
import TextractContext from '../../../contexts/TextractContext';

const ValidationSelector = ({ client, setClient }) => {
  const {CLIENTS} = useContext(TextractContext)

  return (
    <FormControl variant="outlined" style={{ width: 300 }}>
      <InputLabel id="client-label">Client</InputLabel>
      <Select
        label="Client"
        labelId="client-label"
        value={client}
        onChange={(e) => setClient(e.target.value)}
        displayEmpty
      >
        
        <MenuItem value="all">All</MenuItem>
        {CLIENTS.map(c => {
          return <MenuItem value={c.id}>{c.name}</MenuItem>
        })}
      </Select>
    </FormControl>
  );
};

export default ValidationSelector;
